import { faCircleNotch } from "@fortawesome/pro-solid-svg-icons/faCircleNotch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Backdrop, Typography } from "@mui/material";
import { MprcRequestIndicatorType } from "components/MprcRequestIndicator";
import * as React from "react";

interface MprcRequestIndicatorWrapperProps extends React.PropsWithChildren {
    requestIndicator?: MprcRequestIndicatorType;
}

export const MprcRequestIndicatorWrapper = ({ children, requestIndicator }: MprcRequestIndicatorWrapperProps) => {
    return <>
        <Backdrop
            sx={{ position: 'absolute', color: "rgba(0, 0, 0, 0.2)", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={requestIndicator != null}
        >
            <Typography color={requestIndicator == "request" ? "primary.main" : "warning.main"}>
                <FontAwesomeIcon size="3x" fixedWidth spin icon={faCircleNotch} />
            </Typography>
        </Backdrop>

        {children}
    </>;
};